var map = {
	"./Home.vue": [
		"bb51",
		"chunk-51a43afc"
	],
	"./Kontakt.vue": [
		"8fad",
		"chunk-a93b30f0"
	],
	"./Misja.vue": [
		"51f2",
		"chunk-76988958"
	],
	"./Montessori.vue": [
		"71f1",
		"chunk-5626e734"
	],
	"./ONas.vue": [
		"a5e1",
		"chunk-59e46a9b"
	],
	"./Rekrutacja.vue": [
		"1682",
		"chunk-029ebfb1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;